var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivePackageCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3501 16.7571L18.3501 18.7571L22.3501 14.7571",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3501 10.7571V8.7571C21.3497 8.40638 21.2572 8.06191 21.0816 7.75827C20.9061 7.45462 20.6538 7.20247 20.3501 7.0271L13.3501 3.0271C13.0461 2.85157 12.7012 2.75916 12.3501 2.75916C11.999 2.75916 11.6541 2.85157 11.3501 3.0271L4.3501 7.0271C4.04636 7.20247 3.79408 7.45462 3.61856 7.75827C3.44304 8.06191 3.35046 8.40638 3.3501 8.7571V16.7571C3.35046 17.1078 3.44304 17.4523 3.61856 17.7559C3.79408 18.0596 4.04636 18.3117 4.3501 18.4871L11.3501 22.4871C11.6541 22.6626 11.999 22.7551 12.3501 22.7551C12.7012 22.7551 13.0461 22.6626 13.3501 22.4871L15.3501 21.3471",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8501 5.0271L16.8501 10.1771",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64014 7.75708L12.3501 12.7571L21.0601 7.75708",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3501 22.7571V12.7571",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePackageCheck);
export default __webpack_public_path__ + "static/media/active-package-check.c23d67b06643670f5e6ffe3f3eeb0090.svg";
export { ForwardRef as ReactComponent };